'use client';

export default function ObrasHomeSkeleton() {
    return (
        <section className="py-5 w-full flex justify-center px-5">
            <div className="relative w-full max-w-[1400px] h-[500px] rounded-xl flex items-center justify-center gap-4">
                {[1, 2, 3, 4].map((i) => (
                    <div
                        key={i}
                        className={`flex-shrink-0 w-[250px] md:w-[300px] h-[320px] md:h-[400px] rounded-xl bg-neutral-800 animate-pulse ${
                            i === 2 ? 'scale-110' : 'opacity-70'
                        }`}
                    />
                ))}
            </div>
        </section>
    );
}
